<template>
  <div id="app">
    <Loading :visible="isLoading" />
    <!-- 头部 start -->
    <data-open-header title="文档资料" active = "file-data">
    </data-open-header>
    <!-- 头部 end -->
    <!-- main start -->
    <Main></Main>
    <!-- main end -->
    <!-- 底部 start -->
    <data-open-footer></data-open-footer>
    <!-- 底部 end -->
  </div>
</template>

<script>
import Loading from "../../common/components/loading";
import DataOpenFooter from "../../common/components/DataOpenFooter/index";
import DataOpenHeader from '../index/components/head'
import Main from './components/main.vue'
export default {
  name: "app",
  components: {
    Loading,
    DataOpenHeader,
    DataOpenFooter,
    Main
  },
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    this.$root.$on("loading", (is) => {
      this.isLoading = is;
    })
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@space: 8px;
#app {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100%;
  background: #f7f8fc;
  .app__nav {
    padding: @space;
  }
}
</style>
